import { css } from "emotion";
import { Link } from "preact-router/match";
import LogoServices from "../../services/LogoServices";
import { max, lastOfType, firstOfType } from "../../utils/CssUtils";
import CMSComponent from "../CMSComponent";
import SignUpButton from "../global/SignUpButton";
import MobileMenu from "../MobileMenu";
import Dropdown from "../Menus/Dropdown";
import { render, Component } from "preact";

const headerLogo = LogoServices.getLogo("purplePurple");

const wrapper = css({
  height: 70,
  h1: {
    textIndent: -999999,
    float: "left",
    width: 0,
    height: 0
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0px 40px",
  boxShadow: "0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  position: "inherit",
  zIndex: 100,
  "@media(max-width: 990px)": {
    alignItems: "center",
    padding: "0px 14px"
  }
});

const logo = css({
  alignSelf: "center",
  marginTop: 16,
  [max(990)]: {
    marginTop: 12,
    img: {
      height: 24,
      width: 140
    }
  }
});

const navigationSection = css({
  display: "flex",
  alignItems: "baseline",
  ul: {
    listStyleType: "none",
    display: "flex",
    alignItems: "center"
  },
  li: {
    marginRight: 14,
    h3: {
      fontSize: 14
    },
    a: {
      fontSize: 14
    },
    "&:nth-last-child(2)": {
      marginRight: 0
    }
  },
  button: {
    fontSize: 14,
    padding: "0px 16px",
    [firstOfType()]: {
      marginRight: 8
    }
  },
  "#LogIn": {
    fontSize: 16,
    marginRight: "16px",
    color: "#401479",
    fontWeight: 600
  },
  "@media(max-width: 990px)": {
    display: "none"
  }
});

const mobileWrapper = css({
  display: "none",
  zIndex: 1000,
  "@media(max-width: 990px)": {
    display: "initial"
  }
});

const dropDownStyling = css({
  h3: {
    color: "#323232",
    fontWeight: "400 !important"
  },
  button: {
    color: "#323232",
    padding: 0
  },
  marginRight: 0
});

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      about: false,
      help: false
    };
  }

  toggleMenu = (menu, value) => {
    this.setState({
      [menu]: typeof value === "boolean" ? value : !this.state[menu]
    });
  };

  render() {
    const { locale } = this.props;
    return (
      <div className={wrapper}>
        <div className={logo}>
          <h1>Humanitix</h1>
          <Link href={`/${locale}/`} aria-label="Home">
            <img src={headerLogo} alt="Humanitix Logo" />
          </Link>
        </div>
        <div className={navigationSection}>
          <ul>
            {locale !== "us" ? (
              <li>
                <Link
                  activeClassName="link"
                  href={`/${locale}/search`}
                  aria-label="Search"
                >
                  Search events
                </Link>
              </li>
            ) : null}
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/features-and-pricing`}
                aria-label="Features and pricing"
              >
                Features &amp; pricing
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/our-impact`}
                aria-label="Our impact"
              >
                Our impact
              </Link>
            </li>
            <li className={dropDownStyling}>
              <Dropdown
                title="About"
                openToggle={() => this.toggleMenu("about", true)}
                closeToggle={() => this.toggleMenu("about", false)}
                open={this.state.about}
                icon="hollow"
              >
                <div style={{ width: 160 }}>
                  <div style={{ marginBottom: 12 }}>
                    <Link
                      activeClassName="link"
                      href={`/${locale}/accessible-events`}
                      aria-label="Accessible events"
                    >
                      Accessible events
                    </Link>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <Link
                      activeClassName="link"
                      href={`/${locale}/our-model`}
                      aria-label="Our model"
                    >
                      Our model
                    </Link>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <Link
                      activeClassName="link"
                      href={`/${locale}/our-story`}
                      aria-label="Our story"
                    >
                      Our story
                    </Link>
                  </div>
                  <div>
                    <Link
                      activeClassName="link"
                      href={`/${locale}/our-team`}
                      aria-label="Our team"
                    >
                      Our team
                    </Link>
                  </div>
                </div>
              </Dropdown>
            </li>
            <li className={dropDownStyling}>
              <Dropdown
                title="Help"
                openToggle={() => this.toggleMenu("help", true)}
                closeToggle={() => this.toggleMenu("help", false)}
                open={this.state.help}
                icon="hollow"
              >
                <div style={{ width: 160 }}>
                  <div style={{ marginBottom: 12 }}>
                    <a
                      activeClassName="link"
                      href={`https://humanitix.helpdocs.io/category/6tj7pgphsh-event-attendees`}
                      aria-label="Attending an event"
                    >
                      Attending an event
                    </a>
                  </div>
                  <div>
                    <a
                      activeClassName="link"
                      href={`https://humanitix.helpdocs.io/category/1f9mjr3lv6-event-organiser`}
                      aria-label="Hosting an event"
                    >
                      Hosting an event
                    </a>
                  </div>
                </div>
              </Dropdown>
            </li>
          </ul>
          <SignUpButton ariaLabel="Sign in" size="medium" style="hollow">
            Sign in
          </SignUpButton>
          <SignUpButton ariaLabel="create event" size="medium">
            Create event
          </SignUpButton>
        </div>
        <div className={mobileWrapper}>
          <MobileMenu />
        </div>
      </div>
    );
  }
}

export default CMSComponent(null, Header, 70);
